module.exports = __webpack_public_path__ + "img/pic1-2.2aef1271.png";